export default __webpack_public_path__ + "static/media/youtrack.c37f9ef9.svg";